/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectCreateUpdateDashboardDto } from '../../models/project-create-update-dashboard-dto';
import { ProjectResponseDashboardDto } from '../../models/project-response-dashboard-dto';

export interface DashboardProjectsControllerCreateProjectV1$Params {
  
    /**
     * Project data with optional image upload
     */
    body: ProjectCreateUpdateDashboardDto
}

export function dashboardProjectsControllerCreateProjectV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerCreateProjectV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseDashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerCreateProjectV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseDashboardDto>;
    })
  );
}

dashboardProjectsControllerCreateProjectV1.PATH = '/v1/dashboard/projects';
